import React from 'react';
import { connect } from 'react-redux';
import './style/DevTools.scss';
import Button from 'app/ui/core/common/Button';
import {
  pointToDev,
  pointToProd,
  toggleAssetStatus,
  toggleStringDebug,
} from 'app/api/redux-dev/dev-actions';
import UnsafeHtml from 'app/ui/core/common/UnsafeHtml';
import { pointingToProd } from 'app/api/redux-dev/dev-selectors';
import { DEV_BRAND, DEV_LOCALE, DEV_THEME } from 'app/api/redux-route/routes';
import SelectUIBase from 'app/ui/config/SelectUIBase';
import { reloadWithParams } from 'app/utils/route';
import {
  getBrandId,
  getLocaleId,
  getThemeId,
  getUiBase,
} from 'app/api/redux-watson/watson-config-selectors';
import { reset } from 'app/api/redux-ui/common/onboarding/actions';

const LETTER_D = 68;

function DevButton(props) {
  return <Button className="DevTools__Button" {...props} />;
}

class DevTools extends React.Component {
  state = {
    showing: false,
  };

  boundKeyHandler = this.keyEvent.bind(this);

  componentDidMount() {
    window.addEventListener('keyup', this.boundKeyHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.boundKeyHandler);
  }

  keyEvent(e) {
    if (e.keyCode === LETTER_D && e.altKey) {
      this.setState({
        showing: true,
      });
    }
  }

  close() {
    this.setState({
      showing: false,
    });
  }

  handle(fn) {
    fn();
    this.close();
  }

  reload(uiBase) {
    reloadWithParams({
      uiBase,
    });
  }

  render() {
    if (this.state.showing) {
      return (
        <div className="DevTools">
          <div className="DevTools__Inner">
            <Button
              className="DevTools__CloseButton"
              onClick={() => this.close()}
            >
              <UnsafeHtml>&times;</UnsafeHtml>
            </Button>
            {pointingToProd() ? (
              <DevButton onClick={this.props.pointToDev}>
                Point to Dev
              </DevButton>
            ) : (
              <DevButton onClick={this.props.pointToProd}>
                Point to Prod
              </DevButton>
            )}
            <DevButton onClick={() => this.handle(this.props.resetOnboarding)}>
              Reset Onboarding
            </DevButton>
            <DevButton
              onClick={() => this.handle(this.props.toggleStringDebug)}
            >
              Toggle Emojification
            </DevButton>
            <DevButton
              onClick={() => this.handle(this.props.toggleAssetStatus)}
            >
              Toggle Asset Active/Inactive Flags
            </DevButton>
            <DevButton to={DEV_BRAND}>
              View Brand Data ({this.props.brandId}/{this.props.uiBase})
            </DevButton>
            <DevButton to={DEV_THEME}>
              View Theme Data ({this.props.uiBase}/{this.props.themeId})
            </DevButton>
            <DevButton to={DEV_LOCALE}>
              View Locale Data ({this.props.uiBase}/{this.props.localeId})
            </DevButton>
            <SelectUIBase>
              <DevButton onClick={() => this.reload('middle')}>
                Switch to Tween/Middle
              </DevButton>
              <DevButton onClick={() => this.reload('kiddie')}>
                Switch to Kiddie
              </DevButton>
            </SelectUIBase>
          </div>
        </div>
      );
    }
    if (pointingToProd()) {
      return (
        <div className="DevTools__PointingToProd">
          Running in Production Environment
          <Button
            className="DevTools__PointingToProdButton"
            onClick={this.props.pointToDev}
          >
            Reset
          </Button>
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = state => ({
  brandId: getBrandId(state),
  localeId: getLocaleId(state),
  themeId: getThemeId(state),
  uiBase: getUiBase(state),
});

const mapDispatchToProps = dispatch => ({
  toggleStringDebug: () => dispatch(toggleStringDebug()),
  pointToDev: () => dispatch(pointToDev()),
  pointToProd: () => dispatch(pointToProd()),
  resetOnboarding: () => dispatch(reset()),
  toggleAssetStatus: () => dispatch(toggleAssetStatus()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DevTools);
